import React, { useEffect, useState } from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import queryString from 'query-string';
import { useApolloClient } from '@apollo/client';

const LogoutPage = () => {
  const [done, setDone] = useState(false);
  const { addToast } = useToasts();
  const location = useLocation();
  const client = useApolloClient();

  useEffect(() => {
    localStorage.removeItem('auth_token');
    client.resetStore();

    const parsed = queryString.parse(location.search);
    if (parsed && parsed.reason) {
      if (parsed.reason === 'expired') {
        addToast('Die Sitzung ist abgelaufen.', {
          appearance: 'warning',
          autoDismiss: true,
        });
      }
    }

    setDone(true);
  }, [addToast, client, location.search]);

  if (!done) {
    return null;
  }

  return <Redirect to={'/login'} />;
};

export default LogoutPage;
